import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const pageService = {
  getPageDetail,
  editPage,
};

async function getPageDetail(page_id) {
  const url = SERVER_URL + "/page/" + page_id;
  const page = await customFetch("GET", url, null, null);
  return page;
}

async function editPage(page_info) {
  const url =
    SERVER_URL +
    "/org/" +
    page_info.org_id +
    "/dealjacket/" +
    page_info.deal_jacket_id +
    "/page/" +
    page_info.page_id;
  const page = await customFetch("PUT", url, null, JSON.stringify(page_info));
  return page;
}
